﻿export interface Section {
	SectionId: number | null;
	SectionName: string;
	SectionFamilyId: number | null;
	SectionFamilyName: string;
	SortOrder: number | null;
	BilletSize: number | null;
	Description: string | null;
	TonsPerHour: number | null;
	TargetTPH: number | null;
	TargetTPHPercentage: number | null;
	MillYield: number | null;
	FinishedYield: number | null;
	LBsPerFoot: number | null;
	StandDrawingCount: number | null;
	StandCount: number | null;
	HasProductionEvents: boolean;
	IsFirstSection: boolean;
	IsLastSection: boolean;
	IsActive: boolean | null;
}

export const SECTION_INITIAL_VALUES: Section = {
	SectionId: null,
	SectionName: "",
	SectionFamilyId: null,
	SectionFamilyName: "",
	SortOrder: null,
	BilletSize: null,
	Description: null,
	TonsPerHour: null,
	TargetTPH: null,
	TargetTPHPercentage: null,
	MillYield: null,
	FinishedYield: null,
	LBsPerFoot: null,
	StandDrawingCount: null,
	StandCount: null,
	HasProductionEvents: false,
	IsFirstSection: false,
	IsLastSection: false,
	IsActive: true,
};

export interface SectionStand {
	SectionId: string;
	StandId: number | null;
	StandName: number | null;
	SetpointGap: number | null;
	Comments: string;
	StandTypeCode: "U" | "E" | null;
	WidthMeasurement: number | string | null;
	EdgerOrientationCode: "H" | "D" | null;
	Area: number | string | null;
}

export const STAND_TYPE_OPTIONS: { code: "U" | "E"; name: string }[] = [
	{ code: "U", name: "Universal" },
	{ code: "E", name: "Edger" },
];

export const EDGER_ORIENTATION_OPTIONS: {
	code: "H" | "D";
	name: string;
}[] = [
	{ code: "H", name: "Horizontal" },
	{ code: "D", name: "Diagonal" },
];
